


// import React from 'react';

// const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
//   const renderInfo = (label, value) => (
//     <div className="flex items-start gap-2 text-sm">
//       <span className="w-44 font-medium text-gray-300">{label}:</span>
//       <span className="text-white break-words">{value || '—'}</span>
//     </div>
//   );

//   const renderFile = (label, file) => (
//     <div className="flex items-start gap-2 text-sm">
//       <span className="w-44 font-medium text-gray-300">{label}:</span>
//       <span className="text-green-400 break-words">
//         {Array.isArray(file)
//           ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
//           : file?.name || 'Not uploaded'}
//       </span>
//     </div>
//   );

//   return (
//     <div className="space-y-8">
//       {/* Section Title */}
//       <div className="text-center">
//         <h3 className="text-xl font-semibold text-white">Step 3: Review & Submit</h3>
//         <p className="text-gray-400 text-sm mt-1">
//           Please review all details before submitting your registration.
//         </p>
//       </div>

//       {/* School Info */}
//       <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
//         <h4 className="text-white text-lg font-medium mb-4">🏫 School Information</h4>
//         <div className="space-y-2">
//           {renderInfo('School Name', schoolInfo.name)}
//           {renderInfo('Description', schoolInfo.description)}
//           {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
//           {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
//           {renderInfo('Medium of Instruction', schoolInfo.medium)}
//           {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
//           {renderInfo('Email', schoolInfo.email)}
//           {renderInfo('Contact Email', schoolInfo.contactEmail)}
//           {renderInfo('Phone Number', schoolInfo.phone)}
//           {renderInfo('Country', schoolInfo.country)}
//           {renderInfo('State', schoolInfo.state)}
//           {renderInfo('City / District', schoolInfo.city)}
//           {renderInfo('Full Address', schoolInfo.fullAddress)}
//           {renderInfo('Pincode', schoolInfo.pincode)}
//           {renderInfo('Landmark', schoolInfo.landmark || '—')}
//         </div>
//       </div>

//       {/* Documents */}
//       <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
//         <h4 className="text-white text-lg font-medium mb-4">📎 Uploaded Documents</h4>
//         <div className="space-y-2">
//           {renderFile('School Logo', documents.logo)}
//           {renderFile('Banner Image(s)', documents.banner)}
//           {renderFile('Registration Certificate', documents.registrationCert)}
//           {renderFile('Affiliation Letter', documents.affiliationLetter)}
//           {renderFile("Principal's ID", documents.principalID)}
//           {renderFile('PAN Card', documents.panCard)}
//         </div>
//       </div>

//       {/* Actions */}
//       <div className="flex justify-between pt-6">
//         <button
//           onClick={onBack}
//           className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
//         >
//           ← Back
//         </button>
//         <button
//           onClick={onSubmit}
//           className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
//         >
//           🚀 Submit & Launch
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Step3ReviewSubmit;



import React, { useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import SuccessMessage from './SuccessMessage'; // import the success component

const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleFinalSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onSubmit(); // Parent-provided async submit logic
      setIsSuccess(true); // Show success UI
    } catch (err) {
      console.error("Submission failed", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderInfo = (label, value) => (
    <div className="flex items-start gap-2 text-sm">
      <span className="w-44 font-medium text-gray-300">{label}:</span>
      <span className="text-white break-words">{value || '—'}</span>
    </div>
  );

  const renderFile = (label, file) => (
    <div className="flex items-start gap-2 text-sm">
      <span className="w-44 font-medium text-gray-300">{label}:</span>
      <span className="text-green-400 break-words">
        {Array.isArray(file)
          ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
          : file?.name || 'Not uploaded'}
      </span>
    </div>
  );

  if (isSuccess) {
    return <SuccessMessage schoolName={schoolInfo.name}  />;
  }

  return (
    <div className="space-y-8 relative">
      {/* Overlay loader */}
      {isSubmitting && (
        <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 rounded-lg">
          <div className="flex flex-col items-center">
            <ArrowPathIcon className="w-12 h-12 text-emerald-400 animate-spin" />
            <p className="text-white mt-2 text-sm">Submitting, please wait...</p>
          </div>
        </div>
      )}

      {/* Section Title */}
      <div className="text-center">
        <h3 className="text-xl font-semibold text-white">Step 3: Review & Submit</h3>
        <p className="text-gray-400 text-sm mt-1">
          Please review all details before submitting your registration.
        </p>
      </div>

      {/* School Info */}
      <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
        <h4 className="text-white text-lg font-medium mb-4">🏫 School Information</h4>
        <div className="space-y-2">
          {renderInfo('School Name', schoolInfo.name)}
          {renderInfo('Description', schoolInfo.description)}
          {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
          {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
          {renderInfo('Medium of Instruction', schoolInfo.medium)}
          {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
          {renderInfo('Email', schoolInfo.email)}
          {renderInfo('Contact Email', schoolInfo.contactEmail)}
          {renderInfo('Phone Number', schoolInfo.phone)}
          {renderInfo('Country', schoolInfo.country)}
          {renderInfo('State', schoolInfo.state)}
          {renderInfo('City / District', schoolInfo.city)}
          {renderInfo('Full Address', schoolInfo.fullAddress)}
          {renderInfo('Pincode', schoolInfo.pincode)}
          {renderInfo('Landmark', schoolInfo.landmark || '—')}
        </div>
      </div>

      {/* Documents */}
      <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
        <h4 className="text-white text-lg font-medium mb-4">📎 Uploaded Documents</h4>
        <div className="space-y-2">
          {renderFile('School Logo', documents.logo)}
          {renderFile('Banner Image(s)', documents.banner)}
          {renderFile('Registration Certificate', documents.registrationCert)}
          {renderFile('Affiliation Letter', documents.affiliationLetter)}
          {renderFile("Principal's ID", documents.principalID)}
          {renderFile('PAN Card', documents.panCard)}
        </div>
      </div>

      {/* Actions */}
      <div className="flex justify-between pt-6">
        <button
          onClick={onBack}
          className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
        >
          ← Back
        </button>
        <button
          onClick={handleFinalSubmit}
          disabled={isSubmitting}
          className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
        >
          🚀 Submit & Launch
        </button>
      </div>
    </div>
  );
};

export default Step3ReviewSubmit;


